import * as React from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { height: "1em", viewBox: "0 0 14 14", stroke: "currentColor", strokeWidth: 3, xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1L12.9998 12.9997" }), /* @__PURE__ */ React.createElement("path", { d: "M13 1L1.00079 13.0003" }));
export {
  SvgClose as default
};
//# sourceMappingURL=close.js.map
